import { Label, Panel, Table } from 'react-bootstrap';
import { ICenterPerformanceImmediateAttention } from '@nkr/models/center-performance';

interface IProps {
    centerId: number,
    data: ICenterPerformanceImmediateAttention,
    loading: boolean
}

const ImmediateAttention = (props: IProps) => {
    if (props.data == null) {
        return null;
    }

    const { deleteNddList, rccapList, lateSerologyList,
        lateCryoList,
        immediateAttentionCount } = props.data;

    const issueCount =
        deleteNddList.length
        + rccapList.length
        + lateSerologyList.length
        + lateCryoList.length;

    if (props.loading) {
        return (
            <Panel id='data-compliance'>
                <Panel.Heading>
                    <Panel.Title>Issues Requiring Immediate Attention</Panel.Title>
                </Panel.Heading>
                <Panel.Body><Label style={{ fontSize: '100%' }}>Loading data, one moment please...</Label></Panel.Body>
            </Panel>
        );
    }

    return (
        <>
            <Panel>
                <Panel.Heading>
                    <Panel.Title>Issues Requiring Immediate Attention ({immediateAttentionCount})</Panel.Title>
                </Panel.Heading>

                {props.loading ?
                    <Panel.Body><Label style={{ fontSize: '100%' }}>Loading data, one moment please...</Label></Panel.Body>
                    :
                    <Panel.Body>
                        {issueCount == 0 && (
                            <>You have no issues requiring immediate attention</>
                        )}

                        {deleteNddList.length > 0 && (
                            <>
                                <strong>The following chain starters should be either activated, deleted, or have their earliest donation window adjusted:</strong>
                                <ul>
                                    {deleteNddList.map((ndd, index) =>
                                        <li key={'ndd-' + index}><a className='normal' href={'center/' + props.centerId + '/donor/' + ndd.id + '/profile'}>{ndd.alias}</a></li>
                                    )}
                                </ul>
                            </>
                        )}

                        {rccapList.length > 0 && (
                            <>
                                <strong>Avoidable Swap Failures:</strong>
                                <ul>
                                    {rccapList.map((rccap, index) =>
                                        <li key={'rccap-' + index}>Failure Date: {rccap.failDate}. Recipient: {rccap.recipientAlias}. Donor: {rccap.donorAlias}. What Happened: {rccap.whatHappened}</li>
                                    )}
                                </ul>
                            </>
                        )}

                        {lateSerologyList.length > 0 && (
                            <>
                                <div style={{ marginBottom: 10 }}>Serology Results uploaded less than 3 days before donor surgery:</div>
                                <Table condensed bordered>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Donor Alias</th>
                                            <th>Surgery Date</th>
                                            <th>Required Upload on or by</th>
                                            <th>Date Received at NKR Lab</th>
                                            <th>Date Uploaded</th>
                                            <th>Days Late</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lateSerologyList.map((serology, index) =>
                                            <tr key={'lsero-' + index}>
                                                <td>{index + 1}</td>
                                                <td>{serology.donorAlias}</td>
                                                <td>{serology.surgeryDate}</td>
                                                <td>{serology.uploadBy}</td>
                                                <td>{serology.receivedVrl}</td>
                                                <td>{serology.uploadDate}</td>
                                                <td>{serology.daysLate}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </>
                        )}
                    </Panel.Body>
                }
            </Panel>
        </>
    );
}

export default ImmediateAttention;